@if (!loggedIn) {
    <div class="flex justify-center items-center sm:h-[100%]">
        <div class="flex flex-col items-center justify-center my-2">
            <div
                class="flex flex-col gap-2 items-center w-[84vw] h-full sm:w-[70vw] md:w-[60vw] min-h-[360px] py-3 bg-[var(--background-primary-color)] rounded-lg sm:border-[1px] border-[var(--header-border)]">

                @if (!logoId) {
                    <img class="h-[70px] w-auto pl-2 mt-4 cursor-pointer" src="./../../../assets/logo/logo_full.png" alt="logo"
                        [routerLink]="['/home']">
                } @else {
                    <div class="h-[70px] w-auto pl-2 mt-4 cursor-pointer" routerLink="/home">
                        <image [id]="logoId" [props]="'h-[70px] w-auto'"></image>
                    </div>
                }

                <p class="title my-3">Become a part of Growing Community!</p>

                <div class="flex flex-col sm:flex-row sm:flex-wrap justify-between sm:gap-x-2 gap-y-3 sm:gap-y-4 mx-8 w-full px-2 sm:px-8">
                    <text-field class="sm:w-[48%]" label="First Name" [control]="getControl('firstName')"  [corners]="true"></text-field>

                    <text-field class="sm:w-[48%]" label="Last Name" [control]="getControl('lastName')" [corners]="true"></text-field>

                    <text-field class="sm:w-[48%]" label="Mobile" [control]="getControl('contact')" [corners]="true"></text-field>

                    <text-field class="sm:w-[48%]" label="Email" [control]="getControl('email')" [corners]="true"></text-field>

                    <text-field class="sm:w-[48%]" placeholder="Password" label="Password" [control]="getControl('password')" [corners]="true"
                        [type]="passwordType">
                    </text-field>

                    <text-field class="sm:w-[48%]" placeholder="Confirm Password" label="Confirm Password" [corners]="true"
                        [control]="getControl('confirmPassword')" [error]="getErrorMessage('confirmPassword')"
                        [type]="passwordType">
                    </text-field>

                    <p class="w-full flex flex-col gap-2">
                        <checkbox class="mr-2" [value]="showPasswords" label="Show Passwords" (change)="toggleType()" >
                        </checkbox>
                    </p>

                    <dropdown class="sm:w-[48%]" label="User Type" [options]="types" placeholder="Select Value" [corners]="true"
                        [error]="getErrorMessage('type')" [control]="getControl('type')"></dropdown>

                    @if (getValue('type') === 'Member') {
                        <dropdown class="sm:w-[48%]" label="Membership" [corners]="true"
                            [options]="memberships" [keys]="{value:'id', label:'title'}" placeholder="Select Membership"
                            [control]="getControl('membership')">
                        </dropdown>
                    }

                </div>

                <common-button (click)="submit()" class="my-2" label="Register Now" size="L"
                    [disabled]="user.invalid || mismatch || (user.value.type === 'Member' && !user.value.membership)">
                </common-button>
            </div>
            <p class="text-[var(--text-primary)] text-sm font-medium my-4">
                Already have an account?
                <a href="/login" class="link">Log In Now</a>
            </p>
        </div>
    </div>
}
